<template>
<div>
    <v-card flat color="transparent" class="mt-7">
        <v-toolbar  class="bdr secondary2light" :elevation="0" outlined>
            <v-toolbar-title>{{$t('animal.healthRecord')}}</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn
                icon
                large
                :to="{ name: 'AnimalHealthReordEdit', params: {animal_number: $route.params.animal_number}}"
            >
                <v-icon>mdi-pencil-outline</v-icon>
            </v-btn>
            <!-- <v-btn
                icon
                large
                @click="noRecord = !noRecord"
            >
                <v-icon>mdi-cog-outline</v-icon>
            </v-btn> -->
        </v-toolbar>
    </v-card>
    <v-card flat class="mt-7" min-height="600">
        <v-card-text>
            <col-skeleton-loader v-if="loading" :clms="6"></col-skeleton-loader>
            <div v-else>
                <no-record v-if="noRecord"/>
                <health-record v-else />
            </div>
        </v-card-text>
    </v-card>
</div>
</template>
<script>
import AnimalService from "@/_services/AnimalService"
import NoRecord from "./healthrecord/NoRecord.vue"
import HealthRecord from "./healthrecord/HealthRecord.vue"
import ColSkeletonLoader from '@/components/col-skeleton-loader.vue'

export default {
    components: {
        NoRecord,
        HealthRecord,
        ColSkeletonLoader
    },
    created() {
        const fetchData = async () => {
            this.getAnimalHealthRecord(this.$route.params.animal_number)
        }
        fetchData();
        
    },
    data() {
        return {
            loading: true,
            noRecord: true,
            tab: null,
        }
    },
    methods: {
        getAnimalHealthRecord(animalId) {
            AnimalService.getAnimalHealthRecord(animalId)
            .then( res => {
                if(res.data.healthRecord){
                    this.noRecord = false
                }
                this.loading = false;
            })
            .catch(err => {
                console.log(err)
            })
        }
    }
}
</script>
<style lang="scss" scoped>
.bdr {
    border: thin solid $secondary-color;
}
</style>